<template>
    <v-card :to="!this.disabled ? { query: { serviceId: value.id } } : null" :class="classes">
        <v-list style="background:inherit;">
            <div
                v-if="value.defectCount"
                class="caption pr-1"
                align="right"
            >{{value.defectCount}} Scheduled Defect/s
            </div>
            <v-row>
                <div style="min-width:40px" class="ml-4">
                    <v-icon>settings</v-icon>
                </div>
                <div v-if="!value.hasFailedMetrics">
                    <v-chip :small="true">{{value.unitNumber}} ({{value.unitDepartment}})</v-chip>
                </div>
                <div v-if="!!value.hasFailedMetrics">
                    <v-chip :small="true" class="red white--text">{{value.unitNumber}} ({{value.unitDepartment}})</v-chip>
                </div>
                <v-menu>
                    <template v-slot:activator="{ on }">
                        <v-btn height="24" icon text x-small v-on="on" @click="handleClick">
                            <v-icon>info</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <v-list-item-title>{{value.unitNumber}} ({{value.unitDepartment}})</v-list-item-title>
                                <v-list-item-subtitle>{{value.unitName}}</v-list-item-subtitle>
                                <v-list-item-subtitle>{{value.unitGarageLocation}}</v-list-item-subtitle>
                                <v-list-item-subtitle>{{value.unitInstallationAddress}}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-chip v-if="!!value.hasFailedMetrics" class="red white--text">Failed Metrics</v-chip>
                            <v-chip v-if="!!value.isLowUse" class="purple lighten-2 white--text">Low Use Unit</v-chip>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-spacer/>
                <div class="mr-2">
                    <move-menu
                        :value="value"
                        type="service"
                        v-if="!disabled"
                        @move="moveService($event.service, $event.date)"
                    ></move-menu>
                </div>
            </v-row>
            <v-list-item class="chips">
                <v-list-item-content>
                    <v-layout row wrap class="mx-0">
                        <div v-for="task in value.tasks" :key="task.id">
                            <v-chip :class="classes" style="height: auto">{{task.shortName}}</v-chip>
                            <v-chip
                                v-if="task.originalDueAtTolerance || task.originalDueAtTolerance === 0"
                                class="ml-1 mr-3"
                                label
                                small
                                :color="task.originalDueAtTolerance > 0 ? 'red' : null"
                                :dark="task.originalDueAtTolerance > 0 ? true : null"
                            >{{task.originalDueAtTolerance > 0 ? `+${task.originalDueAtTolerance}` : task.originalDueAtTolerance }} {{ task.intervalTypeUnits }}
                            </v-chip>
                        </div>
                    </v-layout>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="value.manuallyMoved">
                <v-list-item-content class="py-0">
                    <span class="overline">(Manually Moved)</span>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-card>
</template>
<script>
  import MoveMenu from '@/components/Calendar/Move/MoveMenu.vue';
  import GarageLocationsClient from '@/components/GarageLocations/GarageLocationsClient.vue';
  import UnitLabel from '@/components/Units/UnitLabel.vue';

  export default {
    props: {
      value: {required: true}
    },
    mixins: [GarageLocationsClient],
    components: {
      MoveMenu,
      UnitLabel
    },
    methods: {
      moveService(service, date) {
        this.$emit('move', {service, date});
      },
      handleClick(e) {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    computed: {
      disabled() {
        const g = this.value.garageLocationId;
        return (this.value.completed && !this.userIsFleetManager)
          || (!this.value.completed && !this.userIsWorkshopManagerInGarage(g, this.userGarages) && !this.userIsDataEntryInGarage(g, this.userGarages) && !this.userIsFleetManager);
      },
      classes() {
        return {
          'ma-1 ': true,
          disabled: this.disabled,
          completed: this.value.completed,
          sweptForward: !this.value.completed && this.value.sweptForwardByScheduler
        };
      }
    }
  };
</script>
<style>
    .disabled {
        cursor: not-allowed;
    }

    .chips {
        height: unset;
    }
</style>
